import {
    Form,
    Button,
} from 'react-bootstrap'
import { NextPage } from 'next'
import React, { useState, useEffect, useRef } from 'react'
import { withI18n } from '~/hocs'
import { AppCommonProps } from 'types/app'
import dynamic from 'next/dynamic'
const Picker = dynamic(() => import('emoji-picker-react'), { ssr: false })
import _ from 'lodash'
import { getAvatar } from '~/utils'
import config from '~/config'
import ReplyInformation from './ReplyInformation'

const CommentReplyItem: NextPage<AppCommonProps> = ({
    t, reply, onHandleUpdate, onHandleDelete, onHandleHide, videoUserID, profile
}: any) => {
    const [showPicker, setShowPicker] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [contentEdit, setContentEdit] = useState("")
    const onEmojiClick = (event: any, emojiObject: { emoji: string }) => {
        setContentEdit(contentEdit + emojiObject.emoji)
    }
    const handleOnChange = (e: any) => {
        setContentEdit(e.target.value)
        const lines = e.target.value.split('\n');
        if (lines[lines.length - 1].match(/^\s*$/) && lines.length > 1) {
            setHeight(`${e.target.scrollHeight - 11}px`)
        } else if (lines.length === 1) {
            setHeight('39px')
        } else {
            setHeight(`${e.target.scrollHeight}px`)
        }
    }
    const handleEditReply = () => {
        if (contentEdit.length > 0) {
            const edits = {
                id: reply.id,
                content: contentEdit,
            }
            onHandleUpdate(edits)
            setContentEdit("")
            setIsEdit(false)
        } else {
            setIsEdit(false)
        }
    }
    const handleDeleteReply = () => {
        onHandleDelete(reply.id)
    }
    const handleHideReply = () => {
        onHandleHide(reply.id)
    }
    const [height, setHeight] = useState('');
    const replyItemRef = useRef()
    return (
        <div className="align-items-center  mt-2 comment-reply">
            <div className="d-flex comment-reply-item mb-2">
                <img className="mr-2 align-self-start" src={reply.avatar && reply.avatar.substring(0, 8) == "property" ? `${config.assetPrefix}/${reply?.avatar}` : getAvatar(reply)} alt="avatar" width="50" />
                <div className="flex-1">
                    <ReplyInformation reply={reply} profile={profile} setIsEdit={setIsEdit} isEdit={isEdit} setHeight={setHeight} videoUserID={videoUserID}
                     replyItemRef={replyItemRef} handleHideReply={handleHideReply} handleDeleteReply={handleDeleteReply} />
                    <div ref={replyItemRef}>
                    {reply.content.split('\n').map((line: any, i: any) => (
                        <>
                            {line}
                            <br />
                        </>
                    ))}
                    </div>
                    {isEdit && <div>
                        <div className="picker-container">
                            <Form.Control as="textarea" defaultValue={reply.content}
                                onChange={(e) => { handleOnChange(e) }} style={{ height }}  />
                            <div className="emoji-container">
                                <img
                                    className="emoji-icon"
                                    alt="true"
                                    src="https://icons.getbootstrap.com/assets/icons/emoji-smile.svg"
                                    onClick={() => setShowPicker((val) => !val)}
                                />
                                <Button variant="primary" type="button" className="ac-btn-sm ac-btn-video rounded-left-0 ml-4 button-comment"
                                    onClick={handleEditReply}>
                                    送信
                                </Button>
                            </div>
                            {showPicker && (
                                <Picker pickerStyle={{ width: "100%" }} onEmojiClick={onEmojiClick} />
                            )}
                        </div>
                    </div>}
                </div>
            </div>
        </div>
    )
}


export default withI18n(CommentReplyItem)
